class Transformer {
    transform(model) {
      throw new Error('You have to implement the method transform!');
    }
  
    collection(collection, params = {}) {
      if (!collection) {
        return [];
      }
  
      let newCollection = [];
  
      for (let i = 0; i < collection.length; i++) {
        const transform = this.transform(collection[i], params);
        newCollection.push(transform);
      }
  
      return newCollection;
    }
  
    item(model) {
      return this.transform(model);
    }
  }
  
  export default Transformer;
  


// WEBPACK FOOTER //
// ./src/requests/transformers/Transformer.js